export default __webpack_public_path__ + "static/media/shuffle.528b7263.svg";